import { Car, Clock, Shield, MapPin, Users, CreditCard, Tv, Music, Star, Phone, Mail, ChevronRight, Heart, Building2, Sparkles, MicVocal } from "lucide-react";

export const navLinks = [
  { label: "Accueil", href: "#accueil" },
  { label: "Services", href: "#services" },
  { label: "Avantages", href: "#avantages" },
  { label: "Contact", href: "#contact" },
];

export const contactInfo = {
  phone: "07 61 84 77 57",
  phoneLink: "tel:+33761847757",
  email: "vtc29chauffeurprive@gmail.com",
  emailLink: "mailto:vtc29chauffeurprive@gmail.com",
  location: "Brest & tout le Finistère",
};

export const heroData = {
  title: "Votre chauffeur privé dans le Finistère",
  subtitle: "Van Mercedes Classe V — 7 passagers",
  description: "Un service haut de gamme pour tous vos déplacements à Brest et dans tout le Finistère. Confort, discrétion et élégance.",
  cta: "Réserver maintenant",
  ctaSecondary: "Découvrir nos services",
  image: "https://customer-assets.emergentagent.com/job_chauffeur-prive-29/artifacts/exc8axmr_2024-11-06-2.jpeg",
  logo: "https://customer-assets.emergentagent.com/job_chauffeur-prive-29/artifacts/awo6h36s_2020-11-12.jpg",
};

export const services = [
  {
    id: "mise-a-disposition",
    title: "Mise à disposition",
    subtitle: "Mariages, séminaires, entreprises",
    description: "Nous mettons à votre disposition notre Van Mercedes Classe V pour tous vos événements. Que ce soit pour un mariage, un séminaire d'entreprise ou tout autre événement, nous vous garantissons un service irréprochable, ponctuel et élégant.",
    features: [
      "Mariages et cérémonies",
      "Séminaires et conférences",
      "Événements d'entreprise",
      "Soirées et galas",
      "Tournées touristiques",
      "Transferts aéroport et gare",
    ],
    image: "https://customer-assets.emergentagent.com/job_chauffeur-prive-29/artifacts/5of6zt1v_PHOTO-2026-03-17-11-53-57.jpg",
    icon: Building2,
  },
  {
    id: "transports-particuliers",
    title: "Transports particuliers",
    subtitle: "Jusqu'à 7 passagers",
    description: "Pour vos déplacements personnels, profitez du confort exceptionnel de notre Van Mercedes Classe V. Que vous voyagiez seul, en couple ou en groupe de 7 personnes, nous vous transportons en toute sérénité.",
    features: [
      "Transferts aéroport et gare",
      "Déplacements longue distance",
      "Sorties en ville",
      "Rendez-vous médicaux (non conventionné)",
      "Shopping et loisirs",
      "Trajets quotidiens",
    ],
    image: "https://customer-assets.emergentagent.com/job_chauffeur-prive-29/artifacts/9zhwyyd9_PHOTO-2026-03-17-11-58-55.jpg",
    icon: Users,
  },
  {
    id: "logistique-culturelle",
    title: "Logistique Culturelle & Tournées",
    subtitle: "L'espace en plus",
    description: "Accompagner le monde de la culture demande une agilité particulière et une compréhension des rythmes de la scène. Grâce à notre Van premium de 7 places, nous offrons une solution sur mesure aux artistes, musiciens et équipes de production. Que ce soit pour rejoindre un festival avec instruments et bagages, ou pour assurer le transfert d'un groupe complet entre l'aéroport et la salle de spectacle, notre véhicule devient un véritable salon mobile.",
    features: [
      "Transferts artistes et équipes de production",
      "Festivals et salles de spectacle",
      "Espace généreux pour instruments et bagages",
      "Ponctualité rigoureuse pour les balances",
      "Flexibilité totale pour les départs tardifs",
      "Confort et sérénité entre les étapes",
    ],
    image: "https://customer-assets.emergentagent.com/job_chauffeur-prive-29/artifacts/ngmo09dh_PHOTO-2026-03-17-11-57-56.jpg",
    icon: MicVocal,
  },
];

export const advantages = [
  {
    title: "Tarif connu à l'avance",
    description: "Pas de surprise, le prix est fixé avant votre trajet. Vous savez exactement ce que vous payez.",
    icon: CreditCard,
  },
  {
    title: "Plus de 7 ans d'expérience",
    description: "Un savoir-faire reconnu et une connaissance parfaite du Finistère pour un service d'exception.",
    icon: Star,
  },
  {
    title: "7 places haut de gamme",
    description: "Van Mercedes Classe V spacieux et confortable, idéal pour les groupes et les familles.",
    icon: Users,
  },
  {
    title: "Ponctualité garantie",
    description: "Nous nous engageons à être à l'heure, pour chaque rendez-vous, chaque transfert.",
    icon: Clock,
  },
  {
    title: "Netflix, Prime Video, Disney+",
    description: "Écran multimédia et tablette avec Spotify à disposition pendant votre trajet.",
    icon: Tv,
  },
  {
    title: "Tout le Finistère",
    description: "Nous intervenons sur Brest et dans tout le département du Finistère, sans limite.",
    icon: MapPin,
  },
];

export const equipments = [
  {
    title: "Ciel étoilé",
    description: "Ambiance unique avec un plafond lumineux à effet ciel étoilé pour un voyage féerique.",
    icon: Sparkles,
  },
  {
    title: "Tablette à disposition",
    description: "Tablette embarquée avec Spotify et applications de divertissement pour les clients.",
    icon: Music,
  },
  {
    title: "Écran multimédia",
    description: "Grand écran à disposition des clients : Netflix, Prime Video, Disney+, YouTube et bien plus encore.",
    icon: Tv,
  },
  {
    title: "Confort premium",
    description: "Sièges en cuir, climatisation, espace généreux pour 7 passagers.",
    icon: Star,
  },
];
